import React from 'react';
// import s from './DetailedProduct.module.css';
import Hero from './Hero';
import MainDescription from './MainDescription/MainDescription';
import Gallery from './Gallery';
import Features from './Features/Features';
import Trailer from './Trailer/Trailer';
import Characteristics from './Characteristics/Characteristics';
import Store from './Store';

function DetailedProduct({ info }) {
  // console.log(info.tableLines[0].characteristics.length);
  return (
    <>
      <Hero background={info.heroBackground} navLogo={info.navLogo} />

      <MainDescription
        mainHeader={info.mainHeader}
        mainTextOne={info.mainTextOne}
        mainTextTwo={info.mainTextTwo}
        mainTextThird={info.mainTextThird ?? info.mainTextThird}
        mainTextFourth={info.mainTextFourth ?? info.mainTextFourth}
        mainTextFifth={info.mainTextFifth ?? info.mainTextFifth}
        mainTextSixth={info.mainTextSixth ?? info.mainTextSixth}
      />

      <Gallery
        backgroundImage={info.galleryBackground}
        firstImageFromList={info.firstImageFromList}
        secondImageFromList={info.secondImageFromList}
        thirdImageFromList={info.thirdImageFromList}
      />

      {info?.featuresFirstText &&
        info?.featuresSecondText &&
        info?.featuresThirdText &&
        info?.featuresFirstBackground &&
        info?.featuresSecondBackground &&
        info?.featuresThirdBackground && (
          <Features
            featuresFirstText={info.featuresFirstText}
            featuresSecondText={info.featuresSecondText}
            featuresThirdText={info.featuresThirdText}
            featuresFirstBackground={info.featuresFirstBackground}
            featuresSecondBackground={info.featuresSecondBackground}
            featuresThirdBackground={info.featuresThirdBackground}
          />
        )}

      {info?.trailerBackground && (
        <Trailer
          trailerBackground={info.trailerBackground}
          trailerSVG={info.trailerSVG}
        />
      )}

      {info?.tableLines[0]?.characteristics.length > 0 &&
        info?.tableLines[1]?.characteristics.length > 0 &&
        info?.tableLines[2]?.characteristics.length > 0 && (
          <Characteristics data={info.tableLines} svg={info.tableSVG} />
        )}

      <Store />
    </>
  );
}

export default DetailedProduct;
